<template>
  <b-form>
    <b-form-group label-for="card_value">
      <b-form-select
          id="card_brand"
          required
          v-model="formCard.card_brand"
          :options="cardBrandOptions"
          placeholder="Loại thẻ"
      ></b-form-select>
    </b-form-group>

    <b-form-group label-for="card_value">
      <b-form-select
          id="card_value"
          required
          v-model="formCard.value"
          :options="cardValueOptions"
          placeholder="Loại thẻ"
      ></b-form-select>
    </b-form-group>

    <b-form-group label-for="card_code">
      <b-form-input
          id="card_code"
          v-model="formCard.code"
          placeholder="Mã thẻ"
          required
      ></b-form-input>
    </b-form-group>

    <b-form-group label-for="card_serial">
      <b-form-input
          id="card_serial"
          v-model="formCard.serial"
          placeholder="Serial thẻ"
          required
      ></b-form-input>
    </b-form-group>

    <b-form-group label-for="g-recaptcha" v-if="website.google_captcha_site_key && website.google_captcha_secret_key && website.enable_recaptcha == 'on'">
      <div class="g-recaptcha" :data-sitekey="website.google_captcha_site_key"></div>
    </b-form-group>

    <b-button @click="submitCard" block variant="primary" :disabled="formDisabled">{{ formSubmitText }}</b-button>
  </b-form>
</template>

<script>
export default {
  name: "TopupCardForm",

  props: {
    website: {
      Type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formCard: {
        card_brand: '',
        value: '',
        code: '',
        serial: '',
        captcha: null,
      },
      cardBrandOptions: [
        {value: '', text: 'Loại thẻ'},
        {value: 'VIETTEL', text: 'Viettel'},
        {value: 'MOBIFONE', text: 'Mobifone'},
        {value: 'VINAPHONE', text: 'Vinaphone'},
        {value: 'VTC', text: 'VTC'},
        {value: 'GATE', text: 'GATE'},
        {value: 'ZING', text: 'ZING'}
      ],
      cardValueOptions: [
        {value: '', text: 'Mệnh giá thẻ'},
        {value: 10000, text: '10.000 vnđ'},
        {value: 20000, text: '20.000 vnđ'},
        {value: 30000, text: '30.000 vnđ'},
        {value: 50000, text: '50.000 vnđ'},
        {value: 100000, text: '100.000 vnđ'},
        {value: 200000, text: '200.000 vnđ'},
        {value: 300000, text: '300.000 vnđ'},
        {value: 500000, text: '500.000 vnđ'},
        {value: 1000000, text: '1.000.000 vnđ'}
      ],
      formDisabled: false,
      formSubmitText: 'Nạp thẻ'
    }
  },
  methods: {
    async depositCard () {
      this.formDisabled = true;
      this.formSubmitText = 'Đang gửi thẻ...';
      try {
        const uri = this.route('fe_card_charge', {domain: this.website.domain});
        if (this.website.enable_recaptcha == 'on') {
          this.formCard.captcha = document.getElementById("g-recaptcha-response").value;
        }
        const response = await this.Request.post(uri, this.formCard);

        if (response.data.status === false) {
          await this.$swal.fire(
              'Có lỗi xảy ra!',
              response.data.message,
              'error'
          );

        } else {
          await this.$swal.fire({
            timer: 2000,
            icon: "success",
            title: 'Thành Công!',
            html: response.data.message,
            showConfirmButton: false,
            width: '400px',
          });

          window.location.reload();
        }
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal.fire(
            'Có lỗi xảy ra!',
            errorMessages[0],
            'error'
        );
      }

      this.formSubmitText = 'Nạp thẻ';
      this.formDisabled = false;
    },
    async submitCard() {
      await this.$swal.fire({
        title: 'Xác nhận!',
        text: 'Bạn thực sự muốn nạp thẻ này?',
        showCancelButton: true,
        confirmButtonText: `Nạp ngay`,
        cancelButtonText: `Huỷ`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.depositCard();
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
